import { create } from 'zustand';
import { axiosInstance } from '@/utils/lib/axios';
import { toast } from 'react-toastify';
import { env } from '@/utils/constants/env';
import { errorHandler } from '@/utils/functions/errorHandler';

export interface IOrgChartUser {
  id: number;
  user_id?: number;
  name: string;
  email: string;
  position?: string;
  user?: {
    id: number;
    name: string;
    email: string;
  };
}

interface OrgChartUserState {
  users: IOrgChartUser[];
  isLoading: boolean;
  error: unknown;

  fetchUsers: (orgChartNodeId: number) => Promise<IOrgChartUser[]>;
  addUserToNode: (orgChartNodeId: number, email: string) => Promise<void>; // ← ubah userId → email
  deleteUserFromNode: (orgChartNodeId: number, userId: number) => Promise<void>;
  clearUsers: () => void;
}

const useOrgChartUserState = create<OrgChartUserState>(set => ({
  users: [],
  isLoading: false,
  error: null,

  clearUsers: () => set({ users: [] }),

  fetchUsers: async orgChartNodeId => {
    set({ isLoading: true });
    try {
      const url = `${env.apiTasklistBaseUrl}/api/v1/compro/org-chart/${orgChartNodeId}/users`;
      const { data } = await axiosInstance.get(url);

      const list = Array.isArray(data) ? data : [];
      set({ users: list, isLoading: false });
      return list;
    } catch (err) {
      errorHandler(err);
      set({ users: [], isLoading: false, error: err });
      return [];
    }
  },

  addUserToNode: async (orgChartNodeId, email) => {
    set({ isLoading: true });
    try {
      const url = `${env.apiTasklistBaseUrl}/api/v1/compro/org-chart/${orgChartNodeId}/users`;
      await axiosInstance.post(url, { email }); // ← kirim email ke backend

      toast.success('User added to node successfully');
      const updated = await useOrgChartUserState.getState().fetchUsers(orgChartNodeId);
      set({ users: updated, isLoading: false });
    } catch (err) {
      errorHandler(err);
      set({ isLoading: false, error: err });
    }
  },

  deleteUserFromNode: async (orgChartNodeId, userId) => {
    set({ isLoading: true });
    try {
      const url = `${env.apiTasklistBaseUrl}/api/v1/compro/org-chart/${orgChartNodeId}/users/${userId}`;
      await axiosInstance.delete(url);

      toast.success('User removed from node successfully');
      const updated = await useOrgChartUserState.getState().fetchUsers(orgChartNodeId);
      set({ users: updated, isLoading: false });
    } catch (err) {
      errorHandler(err);
      set({ isLoading: false, error: err });
    }
  },
}));

export default useOrgChartUserState;
